import {asset} from 'imba';
import url from './mobile1.png';
export default asset({
	url: url,
	type: 'image',
	width: 1204,
	height: 409,
	toString: function(){ return this.url;}
})